import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M17.5 5.084c5.946 1.125 4.351 9.616 1.9 12.659-4.348 5.4-13.027 4.553-16.228-1.69-1.548-2.977-1.555-7.785 1.579-10.969C6.252 3.577 8.023 2.506 9.908 1.98"
    />
    <path
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.2}
      d="M7.843 8.323c.683.86 8.275 7.297 8.275 7.297M8.429 16.28 15.512 8"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const NoIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
